import UserUtil from "@/util/UserUtil";

/**
 * Terminals as the merchant sees them.
 *
 * SUPER_ADMIN can hide a terminal from the merchant (Terminaler → «Skjul for merchant»; CagistaServices
 * terminal/HiddenTerminals) — a test till set up at their location. The server keeps those rows in every terminal
 * list and marks them `hidden: true`; the pages the merchant works with leave them out here — the SAF-T page too, at
 * the founder's choice (2026-10-14). SUPER_ADMIN sees them all, so a hidden till's export can still be produced.
 */
class TerminalVisibility {
    forMerchantView(terminals) {
        const list = Array.isArray(terminals) ? terminals : [];
        return UserUtil.isSuperAdmin() ? list : list.filter((terminal) => !terminal.hidden);
    }
}

export default new TerminalVisibility();
